import { c as _c } from "react/compiler-runtime";
import { FaroBulkDialog } from "@components/common/faro-table/bulk-dialog/bulk-dialog";
import { BulkSuccessDialog } from "@components/common/faro-table/bulk-dialog/bulk-success-dialog";
import { updateSnapshotDetails } from "@store/projects/projects-slice-thunk";
import { useAppDispatch, useAppSelector } from "@store/store-helper";
import { bulkActionNameSelector, selectedEntitiesSelector, shouldShowSuccessDialogSelector } from "@store/table/table-selector";
import { setBulkActionName, updateOne } from "@store/table/table-slice";
import { BulkActionEvents } from "@utils/track-event/track-event-list";
import { useEffect, useState } from "react";
import { isUserSnapshotAdmin } from "@utils/permission-control/snapshot-permission-control";
import { AccessLevelMenuButton } from "@components/access-level/access-level-menu-button";
import { useChangeAccessLevelBulkDialogContent } from "@components/table/projects/bulk-actions/bulk-change-access-level-helper";

/** Show change snapshots access level button and dispatch action where the bulk dialog will act accordingly */
export function BulkChangeSnapshotsAccessLevel() {
  const $ = _c(22);
  const dispatch = useAppDispatch();
  const [shouldShowDialog, setShouldShowDialog] = useState(false);
  const [newAccessLevel, setNewAccessLevel] = useState("private");
  const bulkActionName = useAppSelector(bulkActionNameSelector);
  const shouldShowSuccessDialog = useAppSelector(shouldShowSuccessDialogSelector);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = selectedEntitiesSelector("snapshots");
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const selectedEntities = useAppSelector(t0);
  const {
    bulkDialogContent,
    successDialogContent
  } = useChangeAccessLevelBulkDialogContent("snapshot", newAccessLevel);
  let t1;
  let t2;
  if ($[1] !== shouldShowSuccessDialog) {
    t1 = () => {
      if (shouldShowSuccessDialog) {
        setShouldShowDialog(false);
      }
    };
    t2 = [shouldShowSuccessDialog];
    $[1] = shouldShowSuccessDialog;
    $[2] = t1;
    $[3] = t2;
  } else {
    t1 = $[2];
    t2 = $[3];
  }
  useEffect(t1, t2);
  let t3;
  if ($[4] !== dispatch || $[5] !== selectedEntities) {
    const onAccessLevelChange = function onAccessLevelChange(accessLevel) {
      dispatch(setBulkActionName("changeSnapshotAccessLevel"));
      setNewAccessLevel(accessLevel);
      for (const entity of selectedEntities) {
        const hasUserValidRole = isUserSnapshotAdmin(entity);
        if (!hasUserValidRole) {
          dispatch(updateOne({
            id: entity.id,
            changes: {
              status: "not-allowed",
              message: "You are not allowed to change the access level of this snapshot"
            }
          }));
        }
      }
      setShouldShowDialog(true);
    };
    t3 = <AccessLevelMenuButton type="snapshot" onAccessLevelChange={onAccessLevelChange} />;
    $[4] = dispatch;
    $[5] = selectedEntities;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== bulkActionName || $[8] !== shouldShowSuccessDialog || $[9] !== successDialogContent) {
    t4 = bulkActionName === "changeSnapshotAccessLevel" && shouldShowSuccessDialog && <BulkSuccessDialog dialogContent={successDialogContent} />;
    $[7] = bulkActionName;
    $[8] = shouldShowSuccessDialog;
    $[9] = successDialogContent;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== bulkActionName || $[12] !== bulkDialogContent || $[13] !== dispatch || $[14] !== newAccessLevel || $[15] !== selectedEntities || $[16] !== shouldShowDialog) {
    t5 = bulkActionName === "changeSnapshotAccessLevel" && shouldShowDialog && <FaroBulkDialog dialogContent={bulkDialogContent} onClose={() => setShouldShowDialog(false)} trackingEvent={BulkActionEvents.bulkChangeSnapshotsAccessLevel} bulkActionCallback={snapshot => dispatch(updateSnapshotDetails({
      snapshotId: snapshot.id,
      payload: {
        accessLevel: newAccessLevel
      }
    })).unwrap()} selectedEntities={selectedEntities} uniqueIdKey="id" tableDataType="snapshots" />;
    $[11] = bulkActionName;
    $[12] = bulkDialogContent;
    $[13] = dispatch;
    $[14] = newAccessLevel;
    $[15] = selectedEntities;
    $[16] = shouldShowDialog;
    $[17] = t5;
  } else {
    t5 = $[17];
  }
  let t6;
  if ($[18] !== t3 || $[19] !== t4 || $[20] !== t5) {
    t6 = <>{t3}{t4}{t5}</>;
    $[18] = t3;
    $[19] = t4;
    $[20] = t5;
    $[21] = t6;
  } else {
    t6 = $[21];
  }
  return t6;
}